// composables/useScroller.ts
import { useResizeObserver } from '@vueuse/core'
import { ref, type Ref } from 'vue'

export function useScroll(scroller: Readonly<Ref<HTMLElement | null>>) {
    const topActive = ref(false)
    const bottomActive = ref(true)

    function onVerticalScroll() {
        const el = scroller.value
        if (!el) {
            return
        }

        topActive.value = el.scrollTop > 0
        bottomActive.value = el.scrollTop + el.clientHeight < el.scrollHeight - 1
    }

    useResizeObserver(
        () => [scroller.value, ...[...(scroller.value?.children ?? [])].filter((el) => el instanceof HTMLElement)],
        onVerticalScroll,
    )

    return {
        topActive,
        bottomActive,
        onVerticalScroll,
    }
}
